import type { ReactNode } from 'react'
import { useHasPermission } from '../../hooks/useCan'
import type { Permission } from '../../lib/permissions'
import ForbiddenPage from '../../pages/ForbiddenPage'

interface RequirePermissionProps {
  permission: Permission
  children: ReactNode
}

/**
 * Route guard: renders children only if the current admin holds `permission`,
 * otherwise shows a clean 403. Mirrors the backend route guard so a deep link
 * to a page the role cannot use never renders its data.
 */
export default function RequirePermission({ permission, children }: RequirePermissionProps) {
  const allowed = useHasPermission(permission)
  if (!allowed) {
    return <ForbiddenPage />
  }
  return <>{children}</>
}
